<!--
 * @Author: john 285342894@qq.com
 * @Date: 2024-03-16 16:01:07
 * @LastEditors: john 285342894@qq.com
 * @LastEditTime: 2024-03-16 17:08:44
 * @FilePath: \account\src\pages\components\roles\modal\ShopList.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<div>
		<a-modal title="店铺数据" :width="640" :visible="visible"  @cancel="handleCancel" v-dragModal>
			<template slot="footer" >
				<a-button  key="back"  @click="handleCancel">
					取消
				</a-button>
			</template>
			<a-spin :spinning="loading">
				<div>
					<a-table rowKey="shop_id" :columns="columns" :pagination="false" @change="handleTableChange"
                        :data-source="shopList" :loading="loading">
                    </a-table>
				</div>
			</a-spin>
		</a-modal>
	</div>
</template>

<script>
	export default {
		props: {
			visible:{
				type:Boolean,
				default:false,
			},
			shopList:{
				type: Array,
				default: function(){
                    return [];
                }
			},
		},
		data() {
			return {
				loading: false,
				confirmLoading: false,
				labelCol: { span: 4 },
				wrapperCol: { span: 20 },
				columns: [
					{title: 'ID',dataIndex: 'shop_id', width:70, align: 'left'},
					{title: '店铺名称',dataIndex: 'name',align: 'left', ellipsis: true},
				],
			}
		},
		methods: {
			handleChange(value) {
				console.log(value);
			},
			/**
			 * 取消弹窗
			 */
			handleCancel() {
				this.$emit("cancel");
			},
		}
	}
</script>

<style>

</style>
